module.exports = __webpack_public_path__ + "media/images/Streak-Starter-31a290799708005ea4a2581c62a7d808.svg";